import { Combobox } from '@Components/Combobox';
import { Table } from '@tanstack/react-table';

type SmsOptInFilterValue =
  | {
      operator?: string;
      value?: string;
    }
  | undefined;

interface SmsOptInQuickFilterProps<TData extends object> {
  table: Table<TData>;
}

const SMS_OPT_IN_COLUMN_ID = 'smsOptIn';

const SMS_OPT_IN_ITEMS = [
  { value: '', label: 'All SMS consent' },
  { value: 'true', label: 'SMS opted in' },
  { value: 'false', label: 'SMS not opted in' },
];

export default function SmsOptInQuickFilter<TData extends object>({
  table,
}: SmsOptInQuickFilterProps<TData>) {
  const smsOptInColumn = table.getColumn(SMS_OPT_IN_COLUMN_ID);

  const currentFilter = (smsOptInColumn?.getFilterValue() ??
    undefined) as SmsOptInFilterValue;

  const handleChange = (value?: string) => {
    if (!smsOptInColumn) return;

    if (!value) {
      smsOptInColumn.setFilterValue(undefined);
      return;
    }

    smsOptInColumn.setFilterValue({
      operator: 'equals',
      value,
    });
  };

  return (
    <Combobox
      id="smsOptInFilter"
      items={SMS_OPT_IN_ITEMS}
      value={currentFilter?.value ?? ''}
      onChange={handleChange}
      placeholder="All SMS consent"
      triggerClassName="w-[220px]"
    />
  );
}
